// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-modal_default__2cnaq","active":"idt-modal_active__tojli","overlay":"idt-modal_overlay__v3-uh","container":"idt-modal_container__1hmel"};